const Nux = require('../../api/api-nux').Nux;

const NuxActions = {
  terms: {
    action: function () {
      location.href = '/updated-terms';
    }
  }
};

const getUserExperiences = function (query, accessToken, callback) {
  Nux.read(query, accessToken, function (res) {
    if (res.error || 400 < res.statusCode) {
      return console.log(res.error);
    }
    callback(res, NuxActions);
  });
};

exports.getUserExperiences = getUserExperiences;
